/**
* ContentPlayingAPI.js
* 
* Created on 26-sep-2013, 15:43:30
*
* @author Ivo Swartjes for Ranj
**/

import EventDispatcher from "/lib/html5-software-library/src/ranj/util/EventDispatcher";

// -------------------------------------------------------------------------
// Oz Content player
// -------------------------------------------------------------------------

export class AbstractOzContentPlayer extends EventDispatcher {
    constructor() {
        super();
    }
    contentCompleted(content) { };
};


// -------------------------------------------------------------------------
// Oz Content viewer
// -------------------------------------------------------------------------

export class AbstractOzContentViewer {

    constructor() {
        this.content;
        this.contentPlayer;
    };

    getContentPlayer() {
        return this.contentPlayer;
    };

    setContentPlayer(contentPlayer) {
        this.contentPlayer = contentPlayer;
    };

    getContent() {
        return this.content;
    };

    setContent(content) {
        this.content = content;
    };

    viewContent() { };
}


